import React from 'react';

interface MarkdownRendererProps {
  content: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content }) => {
  return (
    <div style={{
      fontSize: '1.1rem',
      lineHeight: '1.7',
      color: '#f7fafc'
    }}>
      {/* Simple markdown rendering for the executive summary */}
      {content.split('\n').map((paragraph: string, index: number) => {
        if (paragraph.trim() === '') return null;
        
        // Handle markdown headers
        if (paragraph.startsWith('##')) {
          return (
            <h3 key={index} style={{ 
              fontSize: '1.3rem', 
              fontWeight: '600', 
              marginTop: '1rem', 
              marginBottom: '0.5rem',
              color: '#fff'
            }}>
              {paragraph.replace('##', '').trim()}
            </h3>
          );
        }
        
        // Handle markdown bold text
        const processedText = paragraph.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        
        return (
          <p key={index} style={{ marginBottom: '0.75rem' }}>
            <span dangerouslySetInnerHTML={{ __html: processedText }} />
          </p>
        );
      })}
    </div>
  );
};

export default MarkdownRenderer;
